import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import BoilerControlContent from "./McDonnellMillerBoilerControlContent";

class ProductDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route
            path="/products/boiler-controls/mcdonnell-miller"
            exact
            component={BoilerControlContent}
          />
          <Route path="/products/boiler-controls">
            <Redirect to="/products/boiler-controls/mcdonnell-miller" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default ProductDetails;
